/* unplugin-vue-components disabled */import script from "./accout-action.vue?vue&type=script&setup=true&lang=ts"
export * from "./accout-action.vue?vue&type=script&setup=true&lang=ts"

import "./accout-action.vue?vue&type=style&index=0&id=1795a350&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1795a350"]])

export default __exports__